import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ApplyCouponCodeRequest, ApplyCouponCodeResponse } from '../../interface/CustomerRecharge';
import { ApiResponse } from '../../api/api';
import customerRechargeService from '../../services/customerRechargeService';
import { CUSTOMER_RECHARGE_ACTIONS } from '../../constant/stringConstant';

export const applyCouponCode = createAsyncThunk<
  ApiResponse<ApplyCouponCodeResponse>,
  ApplyCouponCodeRequest,
  { rejectValue: string }
>(
  CUSTOMER_RECHARGE_ACTIONS.APPLY_COUPON_CODE,
  async (payload, { rejectWithValue }) => {
    try {
      return await customerRechargeService.applyCouponCode(payload);
    } catch (error) {
      return rejectWithValue(error as any);
    }
  }
);

export interface ApplyCouponCodeState {
  couponResponse: ApiResponse<ApplyCouponCodeResponse> | null;
  loading: boolean;
  error: string | null;
  discountError: string;
}

const initialState: ApplyCouponCodeState = {
  couponResponse: null,
  loading: false,
  error: null,
  discountError: '',
};

const applyCouponCodeSlice = createSlice({
  name: 'applyCouponCode',
  initialState,
  reducers: {
    resetCouponResponse(state) {
      state.couponResponse = null;
    },
    setDiscountError(state, action: PayloadAction<string>) {
      state.discountError = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(applyCouponCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(applyCouponCode.fulfilled, (state, action) => {
        state.loading = false;
        state.couponResponse = action.payload;
        if (action.payload?.Status && action.payload.Status.Status === false) {
          state.discountError = action.payload.Status.DisplayMessage;
        } else {
          state.discountError = '';
        }
      })
      .addCase(applyCouponCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || null;
      });
  },
});

export const { resetCouponResponse, setDiscountError } = applyCouponCodeSlice.actions;
export default applyCouponCodeSlice.reducer;
